<!-- src/app/components/sig-tracker/sig-tracker.component.html -->
<div class="sig-tracker">

  <!-- OVERALL PROGRESS -->
  <div class="tracker-hero">
    <div class="tracker-hero__numbers">
      <span class="tracker-num">{{ totalCollected | number }}</span>
      <span class="tracker-sep">/</span>
      <span class="tracker-goal">{{ totalGoal | number }}</span>
    </div>

    <p class="tracker-hero__label">Doors Knocked Statewide</p>

    <div class="tracker-bar">
      <div
        class="tracker-bar__fill"
        [style.width]="percentComplete + '%'"
      ></div>
    </div>

    <div class="tracker-bar__meta">
      <span class="tracker-pct">{{ percentComplete }}% to goal</span>
      <span class="tracker-deadline">
        Push to Election Day: November 3, 2026
      </span>
    </div>

    <div class="tracker-stats">
      <div class="tracker-stat">
        <span class="tracker-stat__num">{{ countiesWithCaptain }}</span>
        <span class="tracker-stat__label">Counties with Captains</span>
      </div>

      <div class="tracker-stat">
        <span class="tracker-stat__num">
          {{ counties.length - countiesWithCaptain }}
        </span>
        <span class="tracker-stat__label">Counties Needing Captains</span>
      </div>
    </div>
  </div>




  <!-- COUNTIES NEEDING CAPTAINS -->
  <div class="tracker-section">

    <h3 class="tracker-section__title">
      High-Priority Counties Needing Captains
    </h3>

    <p class="tracker-section__sub">
      These counties have the most doors left to knock — step up and lead
      your community.
    </p>

    <div class="priority-grid">

      <div
        *ngFor="let c of countiesNeedingCaptains"
        class="priority-card"
      >
        <span class="priority-card__name">
          {{ c.name }} County
        </span>

        <span class="priority-card__goal">
          Goal: {{ c.goal | number }}
        </span>
      </div>

    </div>

    <div class="tracker-cta">
      <a
        routerLink="/volunteer"
        class="btn-tracker"
      >
        Become a Constitutional Captain
      </a>
    </div>

  </div>

</div>